<template>
  <div id="contentsDetailPage">
    <NavBar  class="overflow-y-hidden"/>
    <div class="row">
      <div class="col-12 col-md-8 col-lg-6 mx-auto">
    <v-main class="overflow-hidden">
    <BackBar :title="contentInfo.Name"/>
    <div v-if="isLoaded" class="container-fluid">
      <div class="row">
        <div class="col-12 ">
          <img :src="$replaceHttps(contentInfo.FileUrl)" alt="تصویر محتوا" class="img-fluid rounded-lg">
        </div>
        <div class="col-12  pt-0">
          <div>
            <a :href="contentInfo.Link" v-if="contentInfo.Link !== null" target="_blank"><i class="fa-solid fa-paperclip font19px"></i></a>
            <span class="float-left third-text">{{$convertDate(contentInfo.ModifiedDate)}}</span>
          </div>
          <div class="mt-6" v-html="contentInfo.Description"></div>
          <div v-if="contentInfo.AparatScript !== null" class="mt-6">
            <div  class="mb-3"><i class="fa-solid fa-play font19px transform-icon ml-2"></i><span class="font16px">ویدیو</span></div>
            <div v-html="contentInfo.AparatScript"></div>
          </div>
        </div>


      </div>
    </div>
    </v-main>
      </div>
    </div>
    <v-overlay :value="showLoaderDialog">
      <div class="loading-spinner">
      </div>
    </v-overlay>
  </div>
</template>

<script>
import BackBar from "@/components/BackBar";
import NavBar from "@/components/NavBar";

export default {
  name: "ContentsDetail",
  metaInfo: {
    title: 'ایوان خانه- جزئیات محتوا',
  },
  components: {NavBar, BackBar},
  data: () => ({
    contentInfo: {},
    isLoaded: false,
    showLoaderDialog: false,
  }),
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.showLoaderDialog= true
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "Publicly/SpecialExtraExtension?ExtraExtensionID="+this.$route.query.ExtraExtensionID, requestOptions)
          .then(response => response.text())
          .then(result => {
            this.contentInfo =JSON.parse(result)
            this.isLoaded= true
            this.showLoaderDialog= false
          })
          .catch(error => console.log('error', error));

         }
  }
}
</script>

<style scoped>

</style>